<div class="bmc-users-list">
  <bzg-modal-header>
    <span class="bz-modal__title">Senior designers from Bogota user group list</span>
    <bzg-button-icon icon="icn-close"></bzg-button-icon>
  </bzg-modal-header>
  <bzg-modal-content class="bz-save-dialog__body">
    <p class="bz-save-dialog__text">
    </p>
  </bzg-modal-content>
  <bzg-modal-footer class="bz-save-dialog__footer">
      <bzg-button-primary class="bz-save-dialog__action">{{ 'GLOBAL.SAVE' | translate}}</bzg-button-primary>
  </bzg-modal-footer>
</div>